module.exports = __webpack_public_path__ + "img/202210-xl.56b36bfa.png";